// extracted by mini-css-extract-plugin
export default {"container":"Centered_container__EnLYG","content":"Centered_content__j-Cmj"};